module.exports = __webpack_public_path__ + "img/ICONS_DT.ddc1294b.png";